import React from "react";
import Navigation from "@/components/Navigation";
import SiteFooter from "@/components/SiteFooter";
import GitPrompt from "@/components/GitPrompt";
import { siteConfig } from "@/data/site";

const Contact = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100">
      <Navigation />
      
      <main className="pt-24 pb-16 px-6">
        <div className="max-w-3xl mx-auto space-y-10">
          <section className="space-y-4">
            <GitPrompt command='git commit -m "say hello"' />
            <p className="text-sm uppercase tracking-[0.2em] text-gray-500 dark:text-gray-400">
              Contact
            </p>
            <h1 className="text-3xl sm:text-4xl font-semibold">Let&apos;s talk.</h1>
            <p className="text-base text-gray-600 dark:text-gray-300">
              I&apos;m open to new collaborations, consulting, and thoughtful engineering
              conversations. Reach out and I&apos;ll reply within 24 hours.
            </p>
          </section>

          <section className="space-y-3">
            <a
              href={`mailto:${siteConfig.email}`}
              className="block rounded-lg border border-gray-200 dark:border-gray-800 p-4 hover:border-gray-400 dark:hover:border-gray-600 transition"
            >
              <p className="text-sm text-gray-500 dark:text-gray-400">Email</p>
              <p className="mt-1 text-base font-medium">{siteConfig.email}</p>
            </a>
            <a
              href={siteConfig.social.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="block rounded-lg border border-gray-200 dark:border-gray-800 p-4 hover:border-gray-400 dark:hover:border-gray-600 transition"
            >
              <p className="text-sm text-gray-500 dark:text-gray-400">LinkedIn</p>
              <p className="mt-1 text-base font-medium">linkedin.com/in/ditikrushnagiri</p>
            </a>
            <a
              href={siteConfig.social.github}
                target="_blank"
                rel="noopener noreferrer"
              className="block rounded-lg border border-gray-200 dark:border-gray-800 p-4 hover:border-gray-400 dark:hover:border-gray-600 transition"
            >
              <p className="text-sm text-gray-500 dark:text-gray-400">GitHub</p>
              <p className="mt-1 text-base font-medium">github.com/ditikrushna</p>
            </a>
          </section>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
};

export default Contact;
